import React, { useMemo } from 'react';
import { createBrowserRouter, RouterProvider, RouteObject } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { RewardsDashboard } from '../reward';
import { Dashboard } from '../dashboard';
import useAmplitude from '../amplitude';
import { useNewRelicAgent } from '../newrelic';

import { DASHBOARD_ROUTE, INVITE_ROUTE, LANDING_ROUTE, REWARD_ROUTE, SURVEY_ROUTE, SUPPORT_ROUTE } from '../constants';
import { AppLayout } from './index';
import { SplashPage } from '../landing';
import InvitePage from '../invite/InvitePage';
import SurveyPage from '../survey/SurveyPage';
import { AuthenticatedSupportView, PublicSupportView } from '../support';

const nonAuthenticatedRoutes: RouteObject[] = [
    { path: LANDING_ROUTE.SPLASH, element: <SplashPage /> },
    { path: SUPPORT_ROUTE.MAIN, element: <PublicSupportView /> },
    { path: INVITE_ROUTE.JOIN, element: <InvitePage /> },
];
const authenticatedRoutes: RouteObject[] = [
    { path: DASHBOARD_ROUTE.MAIN, element: <Dashboard /> },
    { path: DASHBOARD_ROUTE.HOME, element: <Dashboard /> },
    { path: REWARD_ROUTE.MAIN, element: <RewardsDashboard /> },
    { path: SURVEY_ROUTE.MAIN, element: <SurveyPage /> },
    { path: SUPPORT_ROUTE.MAIN, element: <AuthenticatedSupportView /> },
];

export const RouterRoot = () => {
    const auth0 = useAuth0();
    useAmplitude();
    useNewRelicAgent();
    const allRoutes: RouteObject[] = useMemo((): RouteObject[] => {
        return (auth0.isAuthenticated ? [{
            element: <AppLayout />,
            children: authenticatedRoutes
        }] : nonAuthenticatedRoutes);
    }, [auth0.isAuthenticated]);
    const router = useMemo(() => createBrowserRouter(allRoutes), [allRoutes]);
    return auth0.isLoading ? <></> : <RouterProvider router={router} />;
};